import { Injectable } from '@angular/core';
import { EmployeeDto, EmployeeVisitDto } from 'src/api';
import { DateService } from 'src/app/shared/services/date.service';
import { WorkOrderTranslateService } from 'src/app/shared/services/translate-workorder.service';
import { VisitsByEmployee } from 'src/workorders/workorder-detail/employee-visit-details';
import { EmployeeVisit } from 'src/workorders/workorder-employee-visits/employee-visit';

@Injectable({
  providedIn: 'root',
})
export class EmployeeVisitsService {
  constructor(private workOrderTranslateService: WorkOrderTranslateService) {}

  getVisitsByDay(employeeVisitsDto: EmployeeVisitDto[], employees: EmployeeDto[]) {
    const employeeVisits = employeeVisitsDto.map((ev) => {
      const employee = employees.find((e) => e.id == ev.employeeId!);
      let startDate = new Date(ev.startDate!);
      let endDate = new Date(ev.endDate!);

      return {
        id: ev.id,
        startDate: startDate,
        endDate: endDate,
        employeeId: ev.employeeId,
        employeeFullName: employee?.name ? employee?.name : '',
        employeeAbbreviatedName: employee?.name ? this.getEmployeeAbbreviatedName(employee.name) : '',
        display: true,
      } as EmployeeVisit;
    });

    return employeeVisits;
  }

  getVisitsByEmployee(employeeVisitsByDay: EmployeeVisit[]) {
    const groupedByEmployee = employeeVisitsByDay.reduce(function (groups: any, employeeVisit) {
      const employeeId = employeeVisit.employeeId ? employeeVisit.employeeId : 0;
      if (!groups[employeeId]) {
        groups[employeeId] = [];
      }

      groups[employeeId].push(employeeVisit);
      return groups;
    }, {});

    const visitsByEmployee = Object.keys(groupedByEmployee).map((employee) => {
      const employeeVisits: EmployeeVisit[] = groupedByEmployee[employee];

      return {
        employeeId: employeeVisits[0].employeeId,
        employeeAbbreviatedName: employeeVisits[0].employeeAbbreviatedName,
        employeeVisits: employeeVisits,
      } as VisitsByEmployee;
    });

    return visitsByEmployee;
  }

  getEmployeeAbbreviatedName(name: string) {
    let nameArray: string[] = name!.split(' ');
    return nameArray.length > 1 ? `${nameArray[0]} ${nameArray[1].charAt(0)}.` : nameArray[0];
  }

  getEmployeeDisplayNames(employeeNames: string[]) {
    const maxLength = window.innerWidth < 700 ? 16 : 20;
    const orderedNames = employeeNames.sort((a, b) => a.localeCompare(b));
    let namesPlaceholder = '';
    let displayEmployeeNames = '';

    if (orderedNames.join(', ').length > maxLength) {
      for (let i = 0; i < orderedNames.length; i++) {
        namesPlaceholder += orderedNames[i] + '  ';
        const abbreviatedEmployees = this.workOrderTranslateService.translateAbbreviatedEmployees(
          orderedNames.length - (i + 1)
        );

        displayEmployeeNames = namesPlaceholder + abbreviatedEmployees;
        if (displayEmployeeNames.length >= maxLength) {
          displayEmployeeNames = displayEmployeeNames.replaceAll('  ', ', ');
          displayEmployeeNames = this.setCharAt(displayEmployeeNames, displayEmployeeNames.lastIndexOf(','), ' ');
          break;
        }
      }
      return displayEmployeeNames;
    }

    displayEmployeeNames = orderedNames.join(', ');
    return displayEmployeeNames;
  }

  setCharAt(str: string, index: number, char: string) {
    if (index > str.length - 1 || index == -1) {
      return str;
    } else {
      return str.substring(0, index) + char + str.substring(index + 1);
    }
  }

  getTotalHoursForDay(employeeVisits: EmployeeVisit[]) {
    return employeeVisits
      .map((ev) => DateService.calculateTotalHoursBetweenDates(new Date(ev.startDate), new Date(ev.endDate)))
      .reduce(function (a, b) {
        return a + b;
      });
  }
}
